import useSWR from "swr";
import { Network } from "@/utils/network";
import { zodUnsafeValidate } from "@/utils/zod";
import { Calc } from "../types";
import { useCalculator } from "./useCalculator";
import { useCalculatorRequestData } from "./useCalculatorRequestData";

export const useCalculatorUpdate = () => {
  const api = useCalculator((state) => state.api);
  const config = useCalculator((state) => state.config);
  const requestData = useCalculatorRequestData();

  return useSWR(
    Object.values(requestData),
    async () => {
      const { data } = await Network.post<Calc.Api.CalculatorUpdateResponse>(
        api.calculatorUpdate,
        requestData,
      );

      return zodUnsafeValidate(Calc.Api.CalculatorUpdateResponseSchema, data);
    },
    {
      fallbackData: {
        isAuthorized: config.isAuthorized,
        packs: [],
        modules: [],
        content: config.content,
      } satisfies Calc.Api.CalculatorUpdateResponse,
      revalidateOnMount: false,
      revalidateIfStale: true,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: false,
      keepPreviousData: true,
      dedupingInterval: 100,
    },
  );
};
